import React, { ReactNode, CSSProperties } from 'react'
import theme from 'vars/theme'

type SpTitleProps = {
  className?: string
  style?: CSSProperties
  children: ReactNode
  dataDgId?: string
}

export const SpTitle = ({
  className,
  style,
  children,
  dataDgId,
}: SpTitleProps) => {
  return (
    <h1
      className={`text-center m-0 ${className ?? ''}`}
      style={{ fontSize: 20, color: theme.darkGrayPrimary, ...style }}
      data-dg-id={dataDgId}>
      {children}
    </h1>
  )
}
